"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
const BaseComponent_1 = require("../../../../../commons/BaseComponent");
const map_service_1 = require("../../../../../commons/map.service");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../../../map.component");
const _4d_mapper_1 = require("4d-mapper");
const entity_helper_service_1 = require("../../../../../service/entity-helper.service");
const measurement_helper_service_1 = require("../../../../../service/measurement-helper.service");
const Cesium = window.Cesium;
class FeatuerPropertiesViewerComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, snackBar, dialog, location, mapComp, mapService, fourD, entityHelper, mappingHelper) {
        super(router, snackBar, dialog);
        this.route = route;
        this.location = location;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.fourD = fourD;
        this.entityHelper = entityHelper;
        this.mappingHelper = mappingHelper;
        this.props = {};
        this.aprops = {};
        this.features = {};
        this.entity = null;
        this.showAdvanced = false;
        this.objectKeys = Object.keys;
        let me = this.router.getCurrentNavigation();
        if (me && me.extras.state) {
            let checked = mappingHelper.checkMousePosition(me.extras.state.movement, true);
            this.checkObject(me.extras.state.movement, checked);
            // this.props = this.router.getCurrentNavigation().extras.state.featureProperties;
            // this.isFeatureDescription = this.router.getCurrentNavigation().extras.state.isFeatureDescription;
        }
    }
    init() {
        this.mapComp.detailsNav.open();
        this.mapComp.activeDetails = this;
    }
    ngAfterViewInit() {
        this.setFeaturePropertiesDivHtml();
    }
    setFeaturePropertiesDivHtml() {
        // if the featureProperties content is html then place as it is on html
        if (this.featurePropertiesDiv)
            this.featurePropertiesDiv.nativeElement.innerHTML = this.props;
    }
    // transfer properties that exists from the entity object to our featureProperty object
    transferProperties(props, elements, entity) {
        elements.forEach(element => {
            if (entity && entity[element]) {
                props[element] = entity[element];
            }
        });
    }
    cancel() {
        this.navigateBack(this.location);
    }
    clickedMap(movement, rightClick, checkedPosition) {
        // if a right-click, close this component and go back to map.component
        if (rightClick) {
            this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'layers']);
        }
        return this.checkObject(movement, checkedPosition);
    }
    checkObject(movement, checkedPosition) {
        let clickedObject = null;
        this.props = {};
        this.aprops = {};
        this.features = {};
        this.entity = null;
        // console.log ( 'feature-viewer :: checkObject()', checkedPosition, this.mapService.helper );
        if (checkedPosition.tileset) {
            clickedObject = checkedPosition.tileset;
            this.props.kind = 'Tileset';
            // tileset properties
            this.transferProperties(this.aprops, ['_batch_id'], checkedPosition.tileset);
            this.transferProperties(this.aprops, ['id', 'transform_id', 'show', 'alpha', '_tilesLoaded'], checkedPosition.tileset._tileset);
            // resource properties
            // this.transferProperties ( this.aprops, [ 'url' ], checkedPosition.tileset._resource );
            // has it got Properties?
            if (checkedPosition.tileset._content && checkedPosition.tileset._content['featuresLength'] && checkedPosition.tileset._content.featuresLength > 0) {
                // console.log ( "@@@@ a", checkedPosition.tileset.getPropertyNames() );
                checkedPosition.tileset.getPropertyNames().forEach(name => {
                    let p = checkedPosition.tileset.getProperty(name);
                    if (p && (p + '').trim() !== '') {
                        this.props[name] = (p + '').trim();
                    }
                });
                /* refactor; disabled for now
                  const propertyNames = checkedPosition.tileset.getPropertyNames();
                  for (let i = 0; i < propertyNames.length; i++) {
                    this.featureProperties[propertyNames[i]] = checkedPosition.tileset.getProperty(propertyNames[i]);
                  } */
            }
        }
        else if (checkedPosition.feature) {
            clickedObject = checkedPosition.feature;
            this.props.kind = 'Feature';
            // has properties
            if (checkedPosition.feature.properties) {
                this.props = checkedPosition.feature.properties.getValue();
            }
            // base properties
            this.transferProperties(this.props, ['id', 'name', 'show', 'description', 'type'], checkedPosition.feature);
            let props = this.entityHelper.getEntityProperties(checkedPosition.feature.id);
            if (props) {
                // reference properties
                this.transferProperties(this.aprops, ['typeRef', 'shapeRef', 'annotationRef', 'entityRef', 'fourd_ref'], props);
            }
        }
        let res = this.mapService.helper.resolveItem(movement);
        let features = this.checkFeatures(res, clickedObject);
        if (clickedObject) {
            this.entity = clickedObject;
        }
        console.log('feature-viewer :: checkObject()', this.entity, res, features, movement);
        return map_component_1.ClickDisplay.Chevron;
        /*
        if (features && features.length > 0)
          features.forEach(feature => {
            // if (feature instanceof Cesium.Cesium3DTileFeature) {
              var propertyNames = feature.getPropertyNames();
              var length = propertyNames.length;
              for (var i = 0; i < length; i++) {
                var propertyName = propertyNames[i];
                this.featureProperties[propertyName] = feature.getProperty(propertyName);
              }
            // }
          });
        */
        /*
            var feature = features.find(f => f.id);
            if(feature && feature.id && feature.id.properties){
              this.featureProperties = feature.id.properties.getValue();
            }else if (feature && feature.id && feature.id.description) {  // if the featureProperties content is html then place as it is on html
              this.isFeatureDescription = true;
              this.featureProperties = feature.id.description._value;
              this.setFeaturePropertiesDivHtml();
            }else
              return this.mapComp.activeTabObj.clickedMap(movement, rightClick, checkedPosition)
            if (rightClick)
              this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'layers'])
            // pass actions to map
            return ClickDisplay.Chevron;
          }
        */
    }
    // incoming Transform object
    checkFeatures(t, obj = null) {
        // console.log ( 'feature-viewer :: checkFeatures()',t, obj);
        // let t = this.mapService.helper.getMapObjectFor (x);
        let id = t ? (t['id'] ? t['id'] : null) : 'No Transform obj found';
        let ttype = t ? (t['type_uid'] ? t['type_uid'] : null) : 'No Transform obj found';
        let dtype = t ? (t['ds_type_uid'] ? t['ds_type_uid'] : null) : 'No Transform obj found';
        let dsname = t ? (t['ds_name'] ? t['ds_name'] : null) : 'No Transform obj found';
        let features = {
            _: ttype,
            __: dtype,
            ___: dsname,
            transformId: id,
            transformType: ttype,
            entityId: null,
            entityType: null,
            isClickable: false,
            isPointCloud: false,
            isTerrain: false,
            isTileset: false,
            hasProperties: false,
            hasHeight: false,
            minHeight: null,
            maxHeight: null,
            canAlpha: true,
            canColorize: false,
            canHeightAdjust: false
        };
        if (dtype == 'laslaz' || dtype == 'laslaz-tiles' || ttype == 'terrain-tiles') {
            features.canAlpha = false;
            features.canColorize = true;
        }
        if (ttype == 'terrain-tiles') {
            features.isTerrain = true;
        }
        if (ttype == 'three-d-tiles') {
            features.canHeightAdjust = true;
        }
        // let m = this.cesiumHelper.getMapObjectFor(t);
        // if ( m ) {
        // features.object = m;
        // }
        let e = null;
        if (obj) {
            e = obj;
        }
        else {
            e = t ? this.mapService.helper.getCesiumObjectFor(t) : null;
        }
        if (e) {
            // features.entity = e;
            features.entityId = e.id;
            features.entityType = e.constructor.name;
            if (features.entityType == 'ImageryLayer' || (t.transformType && t.transformType.name == 'TMS')) {
                features.isClickable = false;
            }
            else if (features.entityType == 'Cesium3DTileset') {
                features.isClickable = true;
                features.isTileset = true;
                if (e._properties) {
                    features.hasProperties = true;
                    if (e._properties.Height) {
                        features.hasHeight = true;
                        if (e._properties.Height.maximum) {
                            features.maxHeight = e._properties.Height.maximum;
                        }
                        if (e._properties.Height.minimum) {
                            features.minHeight = e._properties.Height.minimum;
                        }
                    }
                }
                if (e.pointCloudShading) {
                    features.isPointCloud = true;
                }
            }
            else {
            }
            // if ( )
        }
        return features;
        // console.log ( '%c layers.comp :: checkAndConfigureFeatures('+t.id+') FOUND FEATURES', 'color:yellow;font-weight:bold;background:blue;font-size:16px;', features, t, e);
    }
}
exports.FeatuerPropertiesViewerComponent = FeatuerPropertiesViewerComponent;
